import type { StoryBeat } from '../stories/types';

export interface Story2Seed {
  id: string;
  title: string;
  /** Kort genre/tone til LLM — vises ikke som resume til eleven. */
  promptContext: string;
  /** 2 narrative åbningslinjer (kun afskrift, ingen huller). */
  openingBeats: StoryBeat[];
}

export const STORY2_SEEDS: Story2Seed[] = [
  {
    id: 'skov',
    title: 'I skoven',
    promptContext:
      'Fortælling i skov/mose med tåge, træer og naturlyde. Rolig eller let spændende tone. Ingen vold.',
    openingBeats: [
      {
        id: 'open-1',
        template: 'tågen hang lavt mellem de høje træer',
      },
      {
        id: 'open-2',
        template: 'et sted længere fremme knagede en gren under nogen',
      },
    ],
  },
  {
    id: 'rum',
    title: 'Rummet',
    promptContext:
      'Sci-fi ved stjerner, rumraket eller rumstation. Undgå skræmmende vold. Humor er ok.',
    openingBeats: [
      {
        id: 'open-1',
        template: 'stjernerne lyste som små huller i det sorte mørke',
      },
      {
        id: 'open-2',
        template: 'raketten stod stille på platformen og ventede',
      },
    ],
  },
  {
    id: 'skole',
    title: 'En skoledag',
    promptContext:
      'Hverdag på skole eller i skolegård. Venner, pause, små oplevelser. Realistisk og venligt.',
    openingBeats: [
      {
        id: 'open-1',
        template: 'klokken ringede og gangen blev fyldt med stemmer',
      },
      {
        id: 'open-2',
        template: 'ved vinduet sad nogen og så ud over den tomme gård',
      },
    ],
  },
  {
    id: 'nat',
    title: 'Om natten',
    promptContext:
      'Stille nat i hus eller by. Måneskin, lyde, små mysterier uden rædsel.',
    openingBeats: [
      {
        id: 'open-1',
        template: 'månen kastede et svagt skær ind gennem gardinet',
      },
      {
        id: 'open-2',
        template: 'alt var stille i huset bortset fra et svagt tikken',
      },
    ],
  },
  {
    id: 'hav',
    title: 'Ved havet',
    promptContext:
      'Kyst, bølger, vind og strand. Eventyr ved vandet, eventuelt et fund eller en rejse.',
    openingBeats: [
      {
        id: 'open-1',
        template: 'bølgerne slog mod stenene med en jævn rytme',
      },
      {
        id: 'open-2',
        template: 'langt ude på vandet blinkede et svagt lys',
      },
    ],
  },
];

const BY_ID = new Map(STORY2_SEEDS.map((s) => [s.id, s]));

export function getStory2Seed(id: string): Story2Seed | undefined {
  return BY_ID.get(id);
}

export function pickStory2Seed(lastSeedId?: string): Story2Seed {
  const pool = lastSeedId
    ? STORY2_SEEDS.filter((s) => s.id !== lastSeedId)
    : STORY2_SEEDS;
  const list = pool.length > 0 ? pool : STORY2_SEEDS;
  return list[Math.floor(Math.random() * list.length)]!;
}
